import React from 'react';
import { Author } from '../../api/Author';
import { RecipeRealization } from '../../api/Types';
import { Avatar, Box, Button, Card, CardBody, Flex, Image, Text } from '../ui';

interface RecipeRealizationCardProps {
  realization: RecipeRealization;
  currentAuthor?: Author | null;
  isCurrentAuthor?: boolean;
  onEdit?: () => void;
}

const RecipeRealizationCard: React.FC<RecipeRealizationCardProps> = ({
  realization,
  currentAuthor = null,
  isCurrentAuthor = false,
  onEdit,
}) => {
  const realizationAuthor = realization.author || (
    isCurrentAuthor && currentAuthor
      ? {
          ...currentAuthor,
          avatar_url: currentAuthor.avatar_url || null,
        }
      : null
  );
  const authorName = [realizationAuthor?.first_name, realizationAuthor?.name]
    .filter(Boolean)
    .join(' ');
  const authorFirstName = realizationAuthor?.first_name || 'cet auteur';

  return (
    <Card as="article" shadow="sm" borderless>
      <CardBody>
        <Flex justify="between" align="center" wrap gap={2} marginBottom={3}>
          <Flex align="center" gap={2}>
            {realizationAuthor?.avatar_url && (
              <Avatar
                src={realizationAuthor.avatar_url}
                alt={`Avatar de ${realizationAuthor.first_name}`}
                size="md"
              />
            )}
            <Box>
              <Text as="div" fontWeight="semibold" marginBottom={0}>
                {isCurrentAuthor ? 'Ma realisation' : authorName}
              </Text>
              <Text as="small" tone="muted">
                {new Date(realization.created_at).toLocaleDateString()}
              </Text>
            </Box>
          </Flex>

          {isCurrentAuthor && onEdit && (
            <Button
              type="button"
              size="sm"
              variant="primary"
              outline
              onClick={onEdit}
            >
              Modifier
            </Button>
          )}
        </Flex>

        {realization.comment && (
          <Text marginBottom={3}>{realization.comment}</Text>
        )}

        {realization.image && (
          <Image
            src={realization.image}
            alt={`Realisation de ${authorFirstName}`}
            fluid
            rounded
            maxHeight="320px"
            objectFit="cover"
          />
        )}
      </CardBody>
    </Card>
  );
};

export default RecipeRealizationCard;
